import { css } from "@emotion/css";
import React, { Fragment, useMemo } from "react";
import { ToolPane } from "./ui-panes/ToolPane";
import { useTheme } from "@mui/material";
import { ToolOptionsPane } from "./ui-panes/ToolOptionsPane";
const getOffsetFromProps = ({ translateX, translateY, ...props }) => {
    const position = props.position;
    const top = props.top || 0;
    const left = props.left || 0;
    if (!Boolean(position))
        return { top, left, translateX, translateY };
    switch (position) {
        case 'bottom': return { top: '100%', left: '50%', translateX: translateX || '-50%', translateY: translateY || '-100%' };
        case 'bottom-left': return { top: '100%', left: 0, translateX, translateY: translateY || '-100%' };
        case 'bottom-right': return { top: '100%', left: '100%', translateX: translateX || '-100%', translateY: translateY || '-100%' };
        case 'center': return { top: '50%', left: '50%', translateX: translateX || '-50%', translateY: translateY || '-50%' };
        case 'left': return { top: '50%', left: 0, translateX, translateY: translateY || '-50%' };
        case 'right': return { top: '50%', left: '100%', translateX: translateX || '-100%', translateY: translateY || '-50%' };
        case 'top': return { top: 0, left: '50%', translateX: translateX || '-50%', translateY };
        case 'top-left': return { top: 0, left: 0, translateX, translateY };
        case 'top-right': return { top: 0, left: '100%', translateX: translateX || '-100%', translateY };
    }
};
const getUIPaneStyle = (theme, props) => {
    const { top, left, translateX, translateY } = getOffsetFromProps(props);
    const transform = Boolean(translateX || translateY) ? [
        translateX ? `translateX(${translateX})` : '',
        translateY ? `translateY(${translateY})` : '',
    ].join(' ').trim() : undefined;
    return css({
        position: 'absolute',
        padding: '0.5em',
        backdropFilter: 'blur(10px)',
        borderRadius: '4px',
        top,
        left,
        transform,
        zIndex: 100,
    });
};
const UIPane = (p) => {
    const { Component, props } = p;
    const theme = useTheme();
    const style = useMemo(() => getUIPaneStyle(theme, p), [theme]);
    const content = React.createElement(Component, { ...props });
    return (content.type === null) ? null : React.createElement("span", { className: style }, content);
};
const FloatingUI = ({ toolPaneProps, toolOptionsPaneProps }) => (React.createElement(Fragment, null,
    React.createElement(UIPane, { Component: ToolPane, props: toolPaneProps, position: "left" }),
    React.createElement(UIPane, { Component: ToolOptionsPane, props: toolOptionsPaneProps, position: "right" })));
export default FloatingUI;
//# sourceMappingURL=FloatingUI.js.map